<template>
  <div>
    <LivenessVerificationV1
      v-if="!useV2"
      ref="activeComponent"
      :id_number="id_number"
      :loadingConfig="loadingConfig"
      @photo-captured="$emit('photo-captured', $event)"
    />
    <LivenessVerificationV2
      v-if="useV2"
      ref="activeComponent"
      :id_number="id_number"
      :enableEmojiMimic="enableEmojiMimic"
      @photo-captured="$emit('photo-captured', $event)"
    />
  </div>
</template>

<script>
import LivenessVerificationV1 from '../liveness_v1/LivenessVerificationV1.vue';
import LivenessVerificationV2 from '../liveness_v2/LivenessVerificationV2.vue';
import { API_BASE_URL } from '@/config';

export default {
  name: "LivenessCheck",
  components: {
    LivenessVerificationV1,
    LivenessVerificationV2,
  },
  props: {
    loadingConfig: {
      type: Object,
      default: () => ({
        useCustomLoader: false,
        messages: {
          idCheck: 'Checking ID...',
          biometricsVerification: 'Verifying biometrics...'
        }
      })
    }
  },
  emits: ['photo-captured'],
  data() {
    return {
      isLive: false,
      id_number: '',
      flags: [],
      useV2: false,
      enableEmojiMimic: false, // New: Default to false as requested
    };
  },
  async mounted() {
    await this.fetchFlags();
    this.useV2 = Array.isArray(this.flags) ? this.flags.some(flag => flag.name === 'liveness_verification_v2' && flag.active) : false;
    this.enableEmojiMimic = Array.isArray(this.flags) ? this.flags.some(flag => flag.name === 'emoji_verification_enabled' && flag.active) : false;
  },
  methods: {
    async fetchFlags() {
      try {
        const response = await fetch(`${API_BASE_URL}/verify_api/system_management_api/feature-flags/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        this.flags = data.flags || [];
      } catch (error) {
        this.flags = [];
      }
    },
    unlockAudio() {
      if (this.$refs.activeComponent && this.$refs.activeComponent.unlockAudio) {
        this.$refs.activeComponent.unlockAudio();
      }
    },
    startFaceRecognition() {
      if (this.$refs.activeComponent && this.$refs.activeComponent.startFaceRecognition) {
        this.$refs.activeComponent.startFaceRecognition();
      }
    },
    set_id_number(id) {
      this.id_number = id;
      if (this.$refs.activeComponent && this.$refs.activeComponent.set_id_number) {
        this.$refs.activeComponent.set_id_number(id);
      }
    },
    close_modal() {
      if (this.$refs.activeComponent && this.$refs.activeComponent.close_modal) {
        this.$refs.activeComponent.close_modal();
      }
    }
  }
};
</script>

<style scoped></style>